import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FitMedProfile } from '@models/data/fit-med-profile/FitMedProfile';
import { GeneralHelperService } from '@services/helpers/general-helper/general-helper.service';
import { ClinicianDashboardRoutes } from '@shared/common/routing/clinician-dashboard-routes';
import { AppAuthService } from '@services/core/auth/app-auth.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { IconsDefinitionHelper } from '@shared/common/definition-helper';
import {hasValue} from '@shared/utils/helpers';
import { GenderComponent } from '../../../../components/gender/gender.component';
import { RouterLink } from '@angular/router';

import { ProfilePictureComponent } from '../../../../components/profile-picture/profile-picture.component';

@Component({
    selector: 'app-ed-fit-med-profile-medium',
    templateUrl: './ed-fit-med-profile-medium.component.html',
    styleUrls: ['./ed-fit-med-profile-medium.component.scss'],
    standalone: true,
    imports: [ProfilePictureComponent, RouterLink, GenderComponent]
})
export class EdFitMedProfileMediumComponent extends IconsDefinitionHelper implements OnInit {
  public customProfilePicture: SafeResourceUrl = null;

  @Input() set nameLinkSubject(content: 'PATIENTS' | 'CLINICIANS') {
    this.nameLink = ClinicianDashboardRoutes[content].view.fullUrl;
  }

  // If other information needs to be inputted instead of whats currently displayed
  @Input() title;
  @Input() subtitle;
  @Input() navigationEnabled = true;
  @Input() mutable = false;

  @Input() set profilePictureSrc(content: SafeResourceUrl) {
    this.customProfilePicture = content;
  }

  @Output() clickedProfilePictureUpdate: EventEmitter<void> =
    new EventEmitter<void>();

  @Input() practitionerId: string = null;
  public patientFitMedProfileId: string = null;
  public nameLink = ClinicianDashboardRoutes.PATIENTS.view.fullUrl;
  public fullName: string = null;
  private fitMedProfileValue?: FitMedProfile = null;

  @Input() set fitMedProfile(content: FitMedProfile) {
    this.fitMedProfileValue = content;

    if (hasValue(content)) {
      this.patientFitMedProfileId = content.id;
      this.fullName = `${content.firstName} ${content.lastName}`;
    }
  }

  public get fitMedProfile(): FitMedProfile {
    return this.fitMedProfileValue;
  }

  constructor(
    private generalHelperService: GeneralHelperService,
    private appAuthService: AppAuthService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  getAgeFromDOB(dob: string): string {
    return this.generalHelperService.dobStringToAge(dob);
  }
}
